<i18n>
  {
    "fr": {
      "admin": {
        "user-list": {
          "title": "Utilisateurs",
          "update-value-tooltip": "Modifier l'utilisateur",
          "delete-value-tooltip": "Supprimer l'utilisateur",
          "add-value-tooltip": "Créer un utilisateur",
          "add-modal": {
            "title": "Créer un utilisateur"
          },
          "update-modal": {
            "title": "Modifier un utilisateur"
          },
          "confirm-delete-title": "Supprimer ?",
          "confirm-delete-content": "Veuillez confirmer la suppression."
        }
      },
      "common": {
        "close": "Fermer",
        "cancel": "Annuler",
        "delete": "Supprimer",
        "create": "Créer",
        "update": "Modifier",
        "ok": "ok",
        "options": "Options",
        "true": "Oui",
        "false": "Non"
      },
      "user": {
        "field": {
          "id": "ID",
          "login": "login",
          "firstname": "Prénom",
          "lastname": "Nom",
          "function": "Fonction",
          "email": "Email",
          "active": "Actif",
          "comment": "Commentaire",
          "roles": "Rôles"
        }
      }
    },
    "de": {

    }
  }
  </i18n>

  <template>
    <div class="admin fullpage list-user">
      <div class="main-content">
        <h1>
          {{ $t('admin.user-list.title') }}
          <md-button class="md-icon-button md-dense md-raised" @click="showUserModal()">
            <md-icon>add</md-icon>
            <md-tooltip>{{ $t('admin.user-list.add-value-tooltip') }}</md-tooltip>
          </md-button>
        </h1>
        <div class="loading" v-if="loading">
          <md-progress-spinner class="loading-animation" :md-diameter="100" :md-stroke="5" md-mode="indeterminate"></md-progress-spinner>
        </div>

        <div class="list-user-content" v-if="!loading">
          <md-table v-if="users.length > 0">
            <md-table-row>
              <md-table-head @click.native="changeSort('id')" :class="{'sort-key': sortKey === 'id', 'desc': revserOrder}">{{ $t('user.field.id') }}</md-table-head>
              <md-table-head @click.native="changeSort('login')" :class="{'sort-key': sortKey === 'login', 'desc': revserOrder}">{{ $t('user.field.login') }}</md-table-head>
              <md-table-head @click.native="changeSort('firstname')" :class="{'sort-key': sortKey === 'firstname', 'desc': revserOrder}">{{ $t('user.field.firstname') }}</md-table-head>
              <md-table-head @click.native="changeSort('lastname')" :class="{'sort-key': sortKey === 'lastname', 'desc': revserOrder}">{{ $t('user.field.lastname') }}</md-table-head>
              <md-table-head @click.native="changeSort('email')" :class="{'sort-key': sortKey === 'email', 'desc': revserOrder}">{{ $t('user.field.email') }}</md-table-head>
              <md-table-head @click.native="changeSort('comment')" :class="{'sort-key': sortKey === 'comment', 'desc': revserOrder}">{{ $t('user.field.comment') }}</md-table-head>
              <md-table-head @click.native="changeSort('function')" :class="{'sort-key': sortKey === 'function', 'desc': revserOrder}">{{ $t('user.field.function') }}</md-table-head>
              <md-table-head @click.native="changeSort('active')" :class="{'sort-key': sortKey === 'active', 'desc': revserOrder}">{{ $t('user.field.active') }}</md-table-head>
              <md-table-head>{{ $t('common.options') }}</md-table-head>
            </md-table-row>
            <md-table-row v-for="user in filtredUsers" :key="user.id">
              <md-table-cell>{{ user.id }}</md-table-cell>
              <md-table-cell>{{ user.login }}</md-table-cell>
              <md-table-cell>{{ user.firstname }}</md-table-cell>
              <md-table-cell>{{ user.lastname }}</md-table-cell>
              <md-table-cell>{{ user.email }}</md-table-cell>
              <md-table-cell>{{ user.comment }}</md-table-cell>
              <md-table-cell>{{ user.function }}</md-table-cell>
              <md-table-cell>{{ $t(`common.${user.active}`) }}</md-table-cell>
              <md-table-cell>
                <md-button class="md-icon-button md-dense" @click="showUserModal(user)">
                  <md-icon>edit</md-icon>
                  <md-tooltip>{{ $t('admin.user-list.update-value-tooltip') }}</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-dense" @click="showConfirmDeleteUser(user)">
                  <md-icon>delete_forever</md-icon>
                  <md-tooltip>{{ $t('admin.user-list.delete-value-tooltip') }}</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>

      <md-dialog class="add-user" :md-active="showAddUserModal" v-on:md-clicked-outside="closeUserModal()">
        <md-dialog-title v-if="modalState === 'create'">{{ $t('admin.user-list.add-modal.title') }}</md-dialog-title>
        <md-dialog-title v-if="modalState === 'update'">{{ $t('admin.user-list.update-modal.title') }}</md-dialog-title>

        <md-dialog-content>
          <div class="modal-content">
            <md-field>
              <label>{{ $t('user.field.login') }}</label>
              <md-input v-model="userToEdit.login"></md-input>
            </md-field>
            <md-field>
              <label>{{ $t('user.field.email') }}</label>
              <md-input v-model="userToEdit.email"></md-input>
            </md-field>
          </div>
          <div class="modal-content">
            <md-field>
              <label>{{ $t('user.field.firstname') }}</label>
              <md-input v-model="userToEdit.firstname"></md-input>
            </md-field>
            <md-field>
              <label>{{ $t('user.field.lastname') }}</label>
              <md-input v-model="userToEdit.lastname"></md-input>
            </md-field>
          </div>
          <div class="modal-content">
            <md-field>
              <label>{{ $t('user.field.function') }}</label>
              <md-input v-model="userToEdit.function"></md-input>
            </md-field>
          </div>
          <div class="modal-content">
            <md-field>
              <label>{{ $t('user.field.comment') }}</label>
              <md-input v-model="userToEdit.comment"></md-input>
            </md-field>
          </div>
          <div class="modal-content">
            <md-checkbox v-model="userToEdit.active">{{ $t('user.field.active') }}</md-checkbox>
          </div>
          <div class="roles-container">
            <span class="md-subheading">{{ $t('user.field.roles') }}</span>
            <div class="roles">
              <div class="role" v-for="role in roles" :key="role.id">
                <md-checkbox v-model="selectedRoles" :value="role.id">
                  <span class="title">#{{ role.id }} - {{ role.name }}</span>
                  <span class="info">{{ role.description }}</span>
                </md-checkbox>
              </div>
            </div>
          </div>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button class="md-primary md-raised" @click="createUser()" v-if="modalState === 'create'">{{ $t('common.create') }}</md-button>
          <md-button class="md-primary md-raised" @click="updateUser()" v-if="modalState === 'update'">{{ $t('common.update') }}</md-button>
          <md-button class="md-primary" @click="closeUserModal()">{{ $t('common.close') }}</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog-confirm
        :md-active.sync="confirmDeleteUser"
        :md-title="$t('admin.user-list.confirm-delete-title')"
        :md-content="$t('admin.user-list.confirm-delete-content')"
        :md-confirm-text="$t('common.delete')"
        :md-cancel-text="$t('common.cancel')"
        @md-cancel="onDeleteUserCanceled"
        @md-confirm="deleteUser"
      />
    </div>
  </template>

  <script>
  import _ from 'lodash'
  import UserProxy from '@/proxies/user'
  import RoleProxy from '@/proxies/role'

  export default {
    name: 'ListObservationPointAdmin',
    data () {
      return {
        loading: true,
        showAddUserModal: false,
        users: [],
        roles: [],
        selectedRoles: [],
        modalState: 'create',
        userToEdit: UserProxy.emptyUser,
        confirmDeleteUser: false,
        userToDelete: null,
        sortKey: 'login',
        revserOrder: false
      }
    },
    computed: {
      filtredUsers () {
        let toReturn = _.sortBy(this.users, [this.sortKey])
        if (this.revserOrder) _.reverse(toReturn)
        return toReturn
      }
    },
    mounted () {
      this.load()
    },
    methods: {
      load () {
        this.loading = true
        let toFetch = [
          UserProxy.list(),
          RoleProxy.list()
        ]
        Promise.all(toFetch).then((data) => {
          this.users = data[0]
          this.roles = data[1]
          this.loading = false
        }).catch(this.handleError)
      },
      showUserModal(user) {
        if (typeof user === 'undefined') {
          user = UserProxy.emptyUser
          this.modalState = 'create'
        } else {
          this.modalState = 'update'
        }

        this.userToEdit = user
        this.selectedRoles = this.userToEdit.roles.map((role) => role.id)
        this.showAddUserModal = true
      },
      closeUserModal () {
        this.showAddUserModal = false
      },
      setRolesOnUserToEdit () {
        this.userToEdit.roles = []
        this.selectedRoles.forEach((roleId) => this.userToEdit.roles.push(this.roles.find((role) => role.id === roleId)))
      },
      async createUser () {
        try {
          this.setRolesOnUserToEdit()
          let user = await UserProxy.create(this.userToEdit)
          await UserProxy.sendInvitation(user)
        } catch (e) { this.handleError(e) }
        this.closeUserModal()
        this.load()
      },
      updateUser () {
        this.setRolesOnUserToEdit()
        UserProxy.update(this.userToEdit).catch(this.handleError).finally(() => {
          this.closeUserModal()
          this.load()
        })
      },
      showConfirmDeleteUser (user) {
        this.userToDelete = user.id
        this.confirmDeleteUser = true
      },
      deleteUser () {
        UserProxy.delete(this.userToDelete).finally(() => {
          this.load()
        })
      },
      onDeleteUserCanceled () {
        this.userToDelete = null
        this.confirmDeleteUser = false
      },
      changeSort (key) {
        if (key === this.sortKey) return this.revserOrder = !this.revserOrder
        this.sortKey = key
        this.revserOrder = false
      },
      handleError(e) {
        console.error(e)
      }
    }
  }
  </script>

  <style lang="scss">
    .admin.fullpage .main-content {
      max-width: unset;
    }
    .add-user .md-dialog-container {
      max-height: 90%;
    }

    .md-table-row {
      user-select: none;
      cursor: pointer;
    }

    .sort-key {
      .md-table-head-label:after {
        content: '▲'
      }
      &.desc .md-table-head-label:after {
        content: '▼'
      }
      .md-table-head-label {
        text-decoration: underline;
      }
    }
  </style>

  <style lang="scss" scoped>
    .list-user {
      h1 {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }

    .modal-content {
      display: flex;
      gap: 10px;
    }

    .md-checkbox {
      margin: 0;
    }

    .roles-container {
      padding-top: 20px;

      .role {
        margin-bottom: 1.5em
      }

      .title {
        font-weight: 600;
        display: block;
      }

      .info {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  </style>
